import Nav from "@/components/Nav";
import ApplyForm from "@/components/ApplyForm";
import ValueProps from "@/components/ValueProps";
import FreeNoticePopup from "@/components/FreeNoticePopup";
import Footer from "@/components/Footer";

export default function ApplyPage() {
  return (
    <>
      <Nav />
      <main>
        <ApplyForm />
        <ValueProps />
      </main>
      <FreeNoticePopup />
      <Footer />
    </>
  );
}
